import type { User } from '@/types/domain/User'

import { getPhoneCode } from '@/constants/phone_code'

/**
 * 表示する電話番号を取得する
 * @param countryCode 国コード (日本: 81)
 * @param phoneNumber 電話番号 (09012345678)
 * @returns 表示用の電話番号
 */
export const getDisplayPhoneNumber = (userPhoneInfo: Pick<User, 'countryCode' | 'phoneNumber'>) => {
  const countryCode = userPhoneInfo?.countryCode ? getPhoneCode(userPhoneInfo.countryCode) : ''

  if (!userPhoneInfo.phoneNumber) {
    return ''
  }
  if (!countryCode) {
    return userPhoneInfo.phoneNumber
  }
  return `+${countryCode}${userPhoneInfo.phoneNumber}`
}

export const formatUserLabel = (value: { userName: string, email: string }) => {
  return `${value.userName}(${value.email})`
}
